<div class="skin-analyzer-banner">
    <a href="javascript:void(0)" (click)="startAnalyzer()" class="button button-primary">
        <span translate="cart.skin.analyzer.start"></span>
    </a>
</div>
